module.exports = __webpack_public_path__ + "static/media/brasao_rs@2x.5da6dc58.png";